import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from "../../shared/helpers/commons";

export const getActiveServices = (filters, token) => {
    const requestHeaders = {
        ...headers,
        Authorization: `Bearer ${token}`
    };
    const url = `${api}/activeservices?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};